import React, { useState, useEffect } from 'react';
import slide1 from '../../assets/slide1.jpg';
import slide2 from '../../assets/slide2.jpg';
import slide3 from '../../assets/slide3.jpg';
import './HeroCarousel.css';

const HERO_SLIDES = [
  {
    headlineBlack: 'Turn Students into Industry-Ready',
    headlineBlue: 'Engineers',
    sub: 'Practical training in Robotics, Embedded Systems, IoT & more',
    btnText: 'BOOK DEMO SESSION',
    btnClass: 'hero__btn--blue',
    bg: slide1,
    badge: null,
  },
  {
    headlineBlack: 'Build Future Innovators from',
    headlineBlue: 'School',
    sub: 'Fun, hands-on Training in Robotics, IoT & Real World Tech',
    btnText: 'BOOK DEMO SESSION',
    btnClass: 'hero__btn--blue',
    bg: slide2,
    badge: null,
  },
  {
    headlineBlack: 'Curious About',
    headlineBlue: 'Robotics?',
    headlineBlack2: 'Join Us Live, Absolutely Free!',
    sub: 'This Saturday: "Introduction to Robotics — Build Your First Robot from Scratch"',
    subExtra: '10:00 AM – 11:30 AM · Live on Zoom / Google Meet',
    btnText: 'Register Free →',
    btnClass: 'hero__btn--green',
    bg: slide3,
    badge: { label: 'FREE WEBINAR', extra: 'EVERY SATURDAY' },
  },
];

function HeroCarousel({ onBookDemo, onRegisterWebinar }) {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((c) => (c + 1) % HERO_SLIDES.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const prev = () => setCurrent((c) => (c - 1 + HERO_SLIDES.length) % HERO_SLIDES.length);
  const next = () => setCurrent((c) => (c + 1) % HERO_SLIDES.length);
  const slide = HERO_SLIDES[current];

  return (
    <div className="hero">

      {/* Background Image */}
      <div
        key={current}
        className="hero__bg"
        style={{ backgroundImage: `url(${slide.bg})` }}
      />

      {/* Gradient Overlay */}
      <div className="hero__overlay" />

      {/* Content */}
      <div className="hero__content">

        {/* Badge — only slide 3 */}
        {slide.badge && (
          <div className="hero__badge-row">
            <span className="hero__badge-dot"></span>
            <span className="hero__badge">{slide.badge.label}</span>
            <span className="hero__badge-extra">{slide.badge.extra}</span>
          </div>
        )}

        {/* Headline */}
        <h1 className="hero__headline">
          {slide.headlineBlack}{' '}
          <span className="hero__headline--blue">{slide.headlineBlue}</span>
          {slide.headlineBlack2 && (
            <>
              <br />
              {slide.headlineBlack2}
            </>
          )}
        </h1>

        {/* Subtitle */}
        {slide.subExtra ? (
          <div className="hero__sub-box">
            <p className="hero__sub">{slide.sub}</p>
            <p className="hero__sub-extra">{slide.subExtra}</p>
          </div>
        ) : (
          <p className="hero__sub">{slide.sub}</p>
        )}

        {/* Button */}
        <button
  className={`hero__btn ${slide.btnClass}`}
  onClick={slide.btnClass === 'hero__btn--green' ? onRegisterWebinar : onBookDemo}
>
  {slide.btnText}
</button>

        {/* Dots */}
        <div className="hero__dots">
          {HERO_SLIDES.map((_, i) => (
            <button
              key={i}
              className={`hero__dot ${i === current ? 'hero__dot--active' : ''}`}
              onClick={() => setCurrent(i)}
            />
          ))}
        </div>

      </div>

      {/* Arrows */}
      <button className="hero__arrow hero__arrow--prev" onClick={prev}>&#8249;</button>
      <button className="hero__arrow hero__arrow--next" onClick={next}>&#8250;</button>

    </div>
  );
}

export default HeroCarousel;